import { render } from "./ContactNameAndPhoto.vue?vue&type=template&id=69abb256&scoped=true"
import script from "./ContactNameAndPhoto.vue?vue&type=script&lang=js"
export * from "./ContactNameAndPhoto.vue?vue&type=script&lang=js"

import "./ContactNameAndPhoto.vue?vue&type=style&index=0&id=69abb256&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69abb256"]])

export default __exports__